export default __webpack_public_path__ + "static/media/SLIDER-Vikkymore-Exchange.6d03c6b7.png";